import { render } from "./inclus.vue?vue&type=template&id=ec09b34e"
import script from "./inclus.vue?vue&type=script&lang=js"
export * from "./inclus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__